module.exports = __webpack_public_path__ + "img/7.b8c5668.jpg";